import { Pipe, PipeTransform } from '@angular/core';
import { IPermissions } from '../../store/documents/documents.reducer';
import { IStyledOption } from '../../framework/constants/documents.constants';

import { BasePermissionsPipe } from './base-permissions.pipe';

@Pipe({
  name: 'optionPermissions',
})
export class OptionsPermissionsPipe extends BasePermissionsPipe implements PipeTransform {
  transform(permissions: Partial<IPermissions>): IStyledOption[] {
    if (!permissions) {
      return [];
    }
    const allPermissions: IStyledOption[] = [];

    this.permissionLiteralToOptions.forEach((permissionLiteralOption) => {
      const option = this.findOption(permissionLiteralOption.value);
      const isPermissionAllowed: 1 | 0 = permissions[permissionLiteralOption.permission]; // will find specific permission 1 or 0
      if (isPermissionAllowed && option) {
        allPermissions.push(option);
      }
    });
    return allPermissions;
  }
}
